import React, { useContext, useState } from 'react';
import { Form, Col, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import api from '../../../api';
import { ModalContext } from '../../../contexts/modal';
import { trackPromise } from 'react-promise-tracker';
import RichGooglePlacesAutoComplete from "../../../autocomplete/RichGooglePlacesAutoComplete";


const FormBuyerIndividual = ({ onFormSubmit, id, userType }) => {
    const { handleModalClose } = useContext(ModalContext);
    const [alert, setAlert] = useState(false);
    const [showPasword, setShowPassword] = useState(false);
    const [showConfirmPasword, setShowConfirmPasword] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    // Registered with FB or google, email, mobile number, address, area, city, category, picture, google location.
    const validSchema = Yup.object().shape({
        email: Yup.string().email().required("Required"),
        cellNumber: Yup.string().required("Required").max(11, 'Phone must contain 11 numbers').min(11, 'Phone must contain 11 numbers'),
        // address: Yup.string().required("Required"),
        city: Yup.string().required("Required"),
        // area: Yup.string().required("Required"),
        category: Yup.string().required("Required"),
        // picture: Yup.string().required("Required"),
        password: Yup.string().required("Required").min(8, "Your password must be at least 8 characters long"),
        conPassword: Yup.string().required('required').oneOf([Yup.ref("password"), null], "Passwords must match").min(8, "Confirm password must be at least 8 characters long"),
    });
    const handleShowPassword = () => {
        showPasword ? setShowPassword(false) : setShowPassword(true)
    }

    const handleShowConfirmPassword = () => {
        showConfirmPasword ? setShowConfirmPasword(false) : setShowConfirmPasword(true)
    }

    async function onSubmit(values) {
        console.log(values)
        try {
            await api.post("/auth/signup", {
                ...values,
                userType,
                role: 'charity'
            });
            handleModalClose();
        } catch (error) {
            setAlert(true);
            setAlertMessage(error.response.data.message)
        }

    };

    return (
        <Formik
            onSubmit={(values) => trackPromise(onSubmit(values), 'register')}
            validationSchema={validSchema}
            enableReinitialize
            initialValues={{
                email: '',
                cellNumber: '',
                // address: '',
                city: '',
                // area: '',
                category: 'widow',
                // picture: '',
                password: '',
                conPassword: ''
            }}
        >
            {(formik) => (
                <Form
                    onSubmit={formik.handleSubmit}
                    id={id}
                >
                    {
                        alert ?
                            <Alert variant="danger" className="rounded text-align-center">{alertMessage}</Alert>
                            : ""
                    }
                    <Form.Row>
                        <Form.Group controlId="email" as={Col} hasValidation>
                            <Form.Label className="form__label">Email</Form.Label>
                            <Form.Control
                                className="p-3 rounded-0"
                                type="text"
                                name="email"
                                placeholder="Enter Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.email && !formik.errors.email}
                                isInvalid={formik.touched.email && formik.errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="cellNumber" as={Col} hasValidation>
                            <Form.Label className="form__label">Mobile</Form.Label>
                            <Form.Control
                                className="p-3 rounded-0"
                                type="text"
                                name="cellNumber"
                                placeholder="03xxxxxxxxx"
                                value={formik.values.cellNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.cellNumber}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        {/* <Form.Group controlId="address" as={Col} hasValidation>
                            <Form.Label className="form__label">Address</Form.Label> */}
                        {/* <Form.Control
                                className="p-3 rounded-0"
                                type="text"
                                name="address"
                                placeholder="Enter Address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.address && !formik.errors.address}
                                isInvalid={formik.touched.address && formik.errors.address}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.address}
                            </Form.Control.Feedback> */}
                        {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.address} placeholder="  Address" onLocationSelect={({ description }) => {
                                formik.setFieldValue('address', description);
                                // setformValues({ ...formValues, city: description })
                            }} />
                        </Form.Group> */}

                        <Form.Group controlId="city" as={Col} hasValidation>
                            <Form.Label className="form__label">City</Form.Label>
                            {/* <Form.Control
                                className="p-3 rounded-0"
                                type="text"
                                name="city"
                                placeholder="Enter City"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.city && !formik.errors.city}
                                isInvalid={formik.touched.city && formik.errors.city}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.city}
                            </Form.Control.Feedback> */}
                            <RichGooglePlacesAutoComplete defaultValue={formik.values.city} placeholder="  City" onLocationSelect={({ description }) => {
                                formik.setFieldValue('city', description);
                                // setformValues({ ...formValues, city: description })
                            }} />
                        </Form.Group>
                        <Form.Group controlId="category" as={Col} hasValidation>
                            <Form.Label className="form__label">Category</Form.Label>
                            <Form.Control
                                className="rounded-0"
                                as="select"
                                name="category"
                                placeholder="Enter Category"
                                value={formik.values.category}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.category && !formik.errors.category}
                                isInvalid={formik.touched.category && formik.errors.category}
                                custom
                            >
                                {/* Widow, 65 year plus, handicap, long sickness, unemployed with marital status */}
                                <option value="widow">Widow</option>
                                <option value="sixtyFiveYearPlus">65+ Years</option>
                                <option value="handicap">Handicap</option>
                                <option value="longSickness">Long Sickness</option>
                                <option value="unemployedWithMaritialStatus">Unemployed With Maritial Status</option>
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.category}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>

                    {/* <Form.Row> */}
                    {/* <Form.Group controlId="area" as={Col} hasValidation>
                            <Form.Label className="form__label">Area</Form.Label> */}
                    {/* <Form.Control
                                className="p-3 rounded-0"
                                type="text"
                                name="area"
                                placeholder="Enter Area"
                                value={formik.values.area}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.area && !formik.errors.area}
                                isInvalid={formik.touched.area && formik.errors.area}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.area}
                            </Form.Control.Feedback> */}
                    {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  Area" onLocationSelect={({ description }) => {
                                formik.setFieldValue('area', description);
                                // setformValues({ ...formValues, city: description })
                            }} />
                        </Form.Group> */}


                    {/* </Form.Row> */}

                    <Form.Row>
                        <Form.Group controlId="password" as={Col} hasValidation>
                            <Form.Label className="form__label">Password</Form.Label>
                            <div style={{ position: "relative", display: "flex" }}>
                                <Form.Control
                                    className="p-3 rounded-0 "
                                    // style={{backG}}
                                    type={showPasword ? "text" : "password"}
                                    name="password"
                                    autoComplete="new-password"
                                    style={{ backgroundImage: 'none' }}
                                    placeholder="Please Enter Your Password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isValid={formik.touched.password && !formik.errors.password}
                                    isInvalid={formik.touched.password && formik.errors.password}
                                />
                                {

                                    showPasword ?
                                        <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                            console.log("password show")
                                            handleShowPassword()
                                        }}></i>
                                        :
                                        <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                            console.log("password show")
                                            handleShowPassword()
                                        }} ></i>
                                }
                            </div>
                            <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                {formik.errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="conPassword" as={Col} hasValidation>
                            <Form.Label className="form__label">Confirm Password</Form.Label>
                            <div style={{ position: "relative", display: "flex" }}>
                                <Form.Control
                                    className="p-3 rounded-0"
                                    type={showConfirmPasword ? "text" : "password"}
                                    name="conPassword"
                                    placeholder="Please Enter Confirm Password"
                                    value={formik.values.conPassword}
                                    style={{ backgroundImage: 'none' }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isValid={formik.touched.conPassword && !formik.errors.conPassword}
                                    isInvalid={formik.touched.conPassword && formik.errors.conPassword}
                                />
                                {

                                    showConfirmPasword ?
                                        <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                            console.log("password show")
                                            handleShowConfirmPassword()
                                        }}></i>
                                        :
                                        <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                            console.log("password show")
                                            handleShowConfirmPassword()
                                        }} ></i>
                                }
                            </div>

                            <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                {formik.errors.conPassword}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    {/* <Form.Row>

                        <Form.Group controlId="picture" as={Col} hasValidation>
                            <Form.Label className="form__label">Picture</Form.Label>
                            <Form.Control
                                // className="p-3 rounded-0"
                                type="file"
                                size="sm"
                                name="picture"
                                placeholder="Enter Picture"
                                value={formik.values.picture}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isValid={formik.touched.picture && !formik.errors.picture}
                                isInvalid={formik.touched.picture && formik.errors.picture}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.area}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col}></Form.Group>
                    </Form.Row> */}
                </Form>
            )
            }
        </Formik >
    )
}

export default FormBuyerIndividual;